var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"navigation-mobile-header"},[_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.openNavigation}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("menu")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }